import Phaser from "phaser";

import {
  PremiumShopScene,
  type PremiumShopSceneCallbacks,
  type PremiumShopVisualState,
} from "./PremiumShopScene";

export type PremiumShopRuntime = {
  game: Phaser.Game;
  scene: PremiumShopScene;
  ready: Promise<void>;
  resize(width: number, height: number): void;
  destroy(): void;
};

const MAX_RENDER_SCALE = 2;

export function createPremiumShopGame(
  parent: HTMLElement,
  callbacks: PremiumShopSceneCallbacks,
  visualState: PremiumShopVisualState,
): PremiumShopRuntime {
  const renderScale = Math.min(MAX_RENDER_SCALE, Math.max(1, window.devicePixelRatio || 1));
  let resolveReady: () => void = () => undefined;
  const ready = new Promise<void>((resolve) => {
    resolveReady = resolve;
  });
  const scene = new PremiumShopScene({ ...callbacks, onReady: resolveReady }, visualState, renderScale);
  const game = new Phaser.Game({
    type: Phaser.CANVAS,
    parent,
    width: Math.round((parent.clientWidth || 360) * renderScale),
    height: Math.round((parent.clientHeight || 800) * renderScale),
    transparent: true,
    antialias: true,
    render: { antialias: true, pixelArt: false, roundPixels: false },
    scale: { mode: Phaser.Scale.NONE, autoCenter: Phaser.Scale.NO_CENTER },
    scene: [scene],
    banner: false,
  });
  return {
    game,
    scene,
    ready,
    resize(width: number, height: number): void {
      game.scale.resize(Math.round(width * renderScale), Math.round(height * renderScale));
    },
    destroy(): void {
      game.destroy(true);
    },
  };
}
